import { render, staticRenderFns } from "./InvInDetailView.vue?vue&type=template&id=4a5bc586&scoped=true&"
import script from "./InvInDetailView.vue?vue&type=script&lang=js&"
export * from "./InvInDetailView.vue?vue&type=script&lang=js&"
import style0 from "./InvInDetailView.vue?vue&type=style&index=0&id=4a5bc586&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5bc586",
  null
  
)

export default component.exports